/**
 * The clinician's stable home hospital, used as the active hospital for
 * path-scoped APIs until a hospital switcher ships (FOOD-559).
 *
 * MNT dual-writes `hospital_id` on create and leaves it unchanged when a
 * second hospital is added, so that column is the home hospital by
 * definition (see `_db_clinician_to_response`). `hospital_ids` arrives
 * newest-first, so the home membership is its last entry, not its first.
 * Reading the first entry pointed multi-hospital clinicians at their most
 * recently added hospital, which hides the home-hospital clinics and
 * patients now that MNT scopes both to the hospital in the request path.
 */
export function clinicianHomeHospitalId(
  clinician:
    | { hospital_ids?: number[] | null; hospital_id?: number | null }
    | null
    | undefined,
): number | undefined {
  if (typeof clinician?.hospital_id === 'number') return clinician.hospital_id;
  const ids = clinician?.hospital_ids;
  if (Array.isArray(ids) && ids.length > 0) return ids[ids.length - 1];
  return undefined;
}
